// import styled from 'styled-components';
// import CustomBlockButton from '../../../../../components/button/CustomBlockButton';

// export const Container = styled.div`
//     padding: 10px;
// `;

// export const Title = {
//     Container: styled.div`
//         display: flex;
//         max-width: 300px;
//         gap: 10px;
//         align-items: center;
//     `,
//     Name: styled.div`
//         font-size: 20px;
//         font-weight: 600;
//     `,
//     AddButton: styled(CustomBlockButton)`
//         width: 60px;
//         height: 30px;
//         font-size: 14px;
//         font-weight: 500;
//         background-color: #333;
//         color: white;
//         border: none;
//         font-weight: 600;
//         border-radius: 3px;
//     `,
// }

// export const StoreList = {
//     Container: styled.div`
//         margin-top: 10px;
//         max-width: 300px;
//         display: flex;
//         flex-direction: column;
//         gap: 10px;
//     `,
//     Item: styled.div`
//         display: flex;
//         gap: 10px;
//         align-items: center;
//         padding: 10px;
//         border: 1px solid #e0e0e0;
//         border-radius: 3px;
//         justify-content: space-between;
//     `,
//     ItemName: styled.div`
//         font-size: 16px;
//         font-weight: 500;
//     `,
//     ItemEditButton: styled(CustomBlockButton)`
//         width: 60px;
//         height: 30px;
//         font-size: 14px;
//         font-weight: 500;
//         background-color: #333;
//         color: white;
//         border: none;
//         font-weight: 600;
//         border-radius: 3px;
//     `,
// }

import styled from "styled-components"
import CustomBlockButton from "../../../../../components/button/CustomBlockButton"

export const Container = styled.div`
  padding: 10px;
`

export const Title = {
  Container: styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  `,
  Name: styled.h2`
    font-size: 24px;
    font-weight: 600;
    color: #333;
  `,
  AddButton: styled(CustomBlockButton)`
    width: auto;
    height: auto;
    padding: 10px 16px;
    font-size: 14px;
    font-weight: 600;
    background-color: #333;
    color: white;
    border: none;
    border-radius: 3px;
  `,
}

export const StoreList = {
  Container: styled.div`
    display: grid;
    gap: 10px;
  `,
  Item: styled.div`
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    background-color: white;
    border-radius: 3px;
    border: 1px solid #efefef;
    transition: background-color 0.3s ease;

    &.selected{
      background-color: #dbefff;
    }
  `,
  ItemName: styled.div`
    font-size: 16px;
    font-weight: 600;
    color: #333;
  `,
  ItemEditButton: styled(CustomBlockButton)`
    width: auto;
    height: auto;
    padding: 8px 12px;
    font-size: 14px;
    font-weight: 600;
    background-color: #333;
    color: white;
    border: none;
    border-radius: 3px;
  `,
}

